import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

interface AssetSearchProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
}

const AssetSearch: React.FC<AssetSearchProps> = ({
  searchValue,
  onSearchChange,
  placeholder = ""
}: AssetSearchProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="w-full py-1">
      <div className="relative w-full group">
        {/* Gradient border effect */}
        <div className="absolute inset-0 rounded-2xl bg-gradient-pink opacity-0 group-focus-within:opacity-100 transition-opacity duration-200 pointer-events-none" 
             style={{
               padding: '1px',
               WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
               mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
               WebkitMaskComposite: 'xor',
               maskComposite: 'exclude'
             }}
        />
        <Search 
          className={cn(
            'absolute left-4 top-1/2 -translate-y-1/2 text-tg-hint pointer-events-none transition-all duration-200',
            'group-focus-within:text-[#FF6B00] group-focus-within:scale-110'
          )} 
          size={20} 
          strokeWidth={1.5} 
        />
        <input
          type="text"
          className={cn(
            'w-full py-4 pl-12 pr-4',
            'border border-black/5 rounded-2xl',
            'bg-tg-secondary-bg text-tg-text',
            'text-base leading-5 transition-all duration-200',
            'shadow-[0_2px_4px_rgba(0,0,0,0.05)] tracking-wide',
            'focus:border-transparent focus:shadow-none focus:outline-none',
            'placeholder:text-tg-hint placeholder:font-medium'
          )}
          placeholder={placeholder || t('HOME_SCREEN.SEARCH.PLACEHOLDER')}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          title={t('HOME_SCREEN.SEARCH.TITLE')}
        />
      </div>
    </div>
  );
}

export default AssetSearch; 